<template>
  <div>
    <!-- 該当bookGroupのbook情報表示 -->
    <div style="margin-bottom: 50px">
      <div v-for="(bookgroup, index) in targetBookGroups" :key="bookgroup.id">
        <MTKBookGroupCard
          :bookgroup="bookgroup"
          :index="index"
          :target-ticket="targetTickets[index]"
          @grandChildMethod="changeRadio"
        />
      </div>
    </div>
    <!-- 該当bookGroupのbook情報表示 -->

    <!-- ボトムのOKボタン -->
    <MTKBottomButton :radio="radio" />
  </div>
</template>

<script>
import MTKMixin from "@/mixins/SetQR/MTKMixin";

export default {
  name: "TheBgRadioForm",
  mixins: [MTKMixin],
  props: {
    targetTickets: {
      type: Array,
      required: true,
    },
    targetBookGroups: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      radio: {},
    };
  },
  mounted() {
    console.log("TheBgRadioForm targetBookGroups", this.targetBookGroups);
  },
  methods: {
    // BookGroupが選ばれたらdataを変更
    changeRadio(radio) {
      this.radio = radio;
    },
  },
};
</script>
